export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14667.bbf4a83f.jpg";